import { NgModule } from '@angular/core';
import { CheckoutDeliveryAddressModule, CheckoutLoginModule } from '@spartacus/checkout/base/components';
import { CostCenterModule, I18nConfig, provideConfig } from '@spartacus/core';
import { PromotionsModule } from '@spartacus/storefront';
import {
  customCheckoutTranslationsChunksConfig,
  customCheckoutTranslationsEn,
  customCheckoutTranslationsEs
} from '../../../../../../../public/translations/custom-checkout-translation-chunk-config';
import { CustomDeliveryModeModule } from './checkout-delivery-mode/custom-checkout-delivery-mode.module';
import { CustomCheckoutOrchestratorModule } from './custom-checkout-orchestrator/custom-checkout-orchestrator.module';
import { CustomCheckoutOrderSummaryModule } from './custom-checkout-order-summary/custom-checkout-order-summary.module';
import { CustomCheckoutProgressMobileBottomModule } from './custom-checkout-progress/custom-checkout-progress-mobile-bottom/custom-checkout-progress-mobile-bottom.module';
import { CustomCheckoutProgressMobileTopModule } from './custom-checkout-progress/custom-checkout-progress-mobile-top/custom-checkout-progress-mobile-top.module';
import { CustomCheckoutProgressModule } from './custom-checkout-progress/custom-checkout-progress.module';
import { CustomPlaceOrderModule } from './custom-place-order/custom-place-order.module';
import { CustomReviewSubmitModule } from './custom-review-submit/custom-review-detail.module';
import { CustomShippingAddressModule } from './custom-shipping-address/custom-shipping-address.module';
import { CustomPaymentMethodModule } from './payment-method/custom-payment-method.module';
import { CustomPaymentTypeModule } from './payment-type/custom-payment-type.module';

@NgModule({
  imports: [
    CustomCheckoutOrchestratorModule,
    CustomCheckoutOrderSummaryModule,
    CustomCheckoutProgressModule,
    CustomCheckoutProgressMobileTopModule,
    CustomCheckoutProgressMobileBottomModule,
    CustomDeliveryModeModule,
    CustomPaymentMethodModule,
    CustomPlaceOrderModule,
    CustomReviewSubmitModule,
    CheckoutLoginModule,
    CustomPaymentTypeModule,
    PromotionsModule,
    CustomShippingAddressModule,
    CostCenterModule,
    CheckoutDeliveryAddressModule
  ],
  providers: [
    provideConfig({
      i18n: {
        resources: { en: customCheckoutTranslationsEn, es: customCheckoutTranslationsEs },
        chunks: customCheckoutTranslationsChunksConfig
      }
    } as I18nConfig)
  ]
})
export class CustomCheckoutComponentModule {}
